import React from 'react';
import ProsesRombelPage from '@/components/rombel/ProsesRombelPage';

// Naik kelas, lanjut semester, pindah rombel, percepatan & kelulusan (lihat ProsesRombelPage).
export default function AdminPromotionsPage() {
  return <ProsesRombelPage badge="Kenaikan & Kelulusan" />;
}
